import { Component } from '@angular/core';
import { BaseButtonSize } from '../../../shared/components/button/base-button.component';
import { BaseExternalUrls } from '../../../shared/enums/base-external-urls.enum';

@Component({
  selector: 'base-error-page-header-nav',
  templateUrl: './base-error-page-header-nav.component.html',
})
export class BaseErrorPageHeaderNavComponent {
  buttonSizes = BaseButtonSize;
  externalUrls = BaseExternalUrls;

  goTo(link: string): void {
    window.open(link, '_blank');
  }
}
